import {
  TextInput as BaseTextInput,
  TextInputProps as BaseTextInputProps,
} from "@ui/agent/components/agent/ui/TextInput";
import { Icon, IconProps } from "../Icon/Icon";

export type TextInputProps = Omit<BaseTextInputProps, "icon" | "hintIcon" | "passwordVisibleIcon" | "passwordHiddenIcon"> & {
  iconName?: string;
  showHint?: boolean;
  iconProps?: IconProps;
  className?: string;
};

import styles from "./TextInput.module.scss";

export const TextInput = ({
  iconName,
  showHint,
  onSubmit,
  inputValue,
  small,
  className,
  crypted,
  withPasswordToggle,
  ...rest
}: TextInputProps): JSX.Element => {
  const icon = iconName ? (
    <Icon
      name={iconName}
      size={small ? "small" : "normal"}
      color={onSubmit ? (inputValue ? "accent" : "grey") : "black"}
      onClick={onSubmit}
      {...rest.iconProps}
      classname={`${styles.icon} ${rest.iconProps?.classname ?? ""}`}
    />
  ) : undefined;

  const hintIcon = showHint ? (
    <Icon name="question" size="small" color="grey" />
  ) : undefined;

  return (
    <BaseTextInput
      {...rest}
      icon={icon}
      hintIcon={hintIcon}
      onSubmit={onSubmit}
      inputValue={inputValue}
      small={small}
      className={className}
      crypted={crypted}
      withPasswordToggle={withPasswordToggle}
      passwordVisibleIcon={<Icon name="eye" size="small" color="black" />}
      passwordHiddenIcon={<Icon name="eyeOff" size="small" color="black" />}
    />
  );
};
